export const SLIDER_MARKS = [
  {
    label: '0',
    value: 0,
  },
  {
    label: '2500',
    value: 2500,
  },
  {
    label: '5000',
    value: 5000,
  },
  {
    label: '7500',
    value: 7500,
  },
  {
    label: '10000',
    value: 10_000,
  },
];
export const CREDIT_MIN_VALUE = 0;
export const CREDIT_MAX_VALUE = 10_000;
export const INPUT_SETTINGS = {
  max: CREDIT_MAX_VALUE,
  min: 0,
  type: 'number',
};
